export const InitialFeedback={
	firstname:"",
    lastname:"",
    telnum:"",
    email:"",
    agree:false,
    contactType:"",
    message:""
};
            